<template>
  <QCard
    :class="cardClasses"
    :style="{ height: height }"
    :flat="flat"
    @click="onClick"
  >
    <slot />
  </QCard>
</template>

<script>
import { QCard } from 'quasar';
export default {
  name: 'SAICardToggle',
  props: {
    spread: Boolean,
    error: Boolean,
    active: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    disable: Boolean,
    flat: {
      type: Boolean,
      default: true
    },
    height: String,
    background: {
      type: String,
      default: 'grey-1'
    },
    activeBackground: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    cardClasses() {
      return {
        'rounded-borders-lg': true,
        'row justify-center items-center': this.spread,
        [this.$attrs.class]: true,
        'sai-card-toggle--error': this.error,
        'cursor-pointer': !this.disable,
        'bdr-a-grey-2-lg': !this.active,
        [`text-${this.color}`]: this.active,
        [`bdr-a-${this.color}-lg`]: this.active,
        [`bg-${this.background}`]: !this.active,
        [`bg-${this.activeBackground}`]: this.active
      };
    }
  },
  methods: {
    onClick(e) {
      if (!this.disable) {
        this.$emit('click', e);
      }
    }
  },
  components: {
    QCard
  }
};
</script>

<style lang="sass" scoped>
.sai-card-toggle--error
  border: 1px solid $negative !important
</style>
